/* App.js, starts code and is wrapped in authentication
* NOTE FROM AUTH0: We are using the 'Authentication API:
* There are 5 authenticatin methods. we use the only one for SPA
* the Client ID method:
* Send the Client ID. 
* For public applications (applications that cannot hold credentials securely, 
* such as SPAs or mobile apps), auth0 offer some endpoints that can only be accessed using Client ID.
*. 20250716: added a check at login for only one dept in auth0 accunt and set selected_agency
*. 20250717: added code to get token and not move on until got token and passit down
*  202500719: added useEffect code to do clean out of ls on logout
*/

import React, { useEffect , useState} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from "react-redux";
import { setProfile } from '../../actions/profile';
import { selectAgencyId } from '../../actions/agencyStubs'; // this is the existing one
import Navbar from '../../views/Navbar/Navbar';
import Main from '../Main/Main';
import PropTypes from 'prop-types';
import './App.css';

// Optional: a Better full-screen loader to wait until authenticated to see componts
const LoadingScreen = () => (
  <div className="loading-screen">
    <p>Authenticating console user. Please wait.</p>
  </div>
);

const App = () => {

const dispatch = useDispatch();
const [isAppReady, setIsAppReady] = useState(false); // we will wait until we are all setup
const reduxProfile = useSelector(state => state.profile || {});
const selectedAgencyId = useSelector((s) => s.agencyStubs.selectedAgencyId);
const [token, setToken] = useState(null);
const {  isAuthenticated, isLoading, loginWithRedirect, error,  user, getAccessTokenSilently } = useAuth0();
const year = new Date().getFullYear();


// Rehydrate profile from localStorage once on mount
useEffect(() => {
  const cachedProfile = localStorage.getItem('profile');
  if (cachedProfile) {
    try {
      const parsedProfile = JSON.parse(cachedProfile);
      dispatch(setProfile(parsedProfile));
      console.log('App.js - Rehydrated profile from localStorage');
    } catch (err) {
      console.error('App.js - Failed to parse cached profile', err);
    }
  }
}, [dispatch]);

// Rehydrate selected agency from localStorage once on mount
useEffect(() => {
  const fromLS = localStorage.getItem("selected_agency");
  if (!selectedAgencyId && fromLS) {
    dispatch(selectAgencyId(fromLS));
    console.log("✅ Rehydrated selectedAgencyId from localStorage:", fromLS);
  }
}, [dispatch, selectedAgencyId]);


/// Redirect to login if not authenticated
  useEffect(() => {
    // If not authenticated and not loading, redirect to login
    if (!isAuthenticated && !isLoading) {
      loginWithRedirect();
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);


    // When Auth0 user changes, set profile in Redux and get token (do NOT set isAppReady here)
  useEffect(() => {
    const setupUser = async () => {
  if (isAuthenticated && user)  {

    // ✅ Pull out the namespaced metadata safely
    const rawAppMetadata = user['https://thebrassstargroup.com/app_metadata'] || {};
    const rawUserMetadata = user['https://thebrassstargroup.com/user_metadata'] || {};

    const structuredProfile = {
      email: user.email, 
      name: user.name,
      sub: user.sub,
      picture: user.picture,
      nickname: user.nickname,
      app_metadata: rawAppMetadata,
      user_metadata: rawUserMetadata,
    };

    dispatch(setProfile(structuredProfile));
    localStorage.setItem('profile', JSON.stringify(structuredProfile));

// HANDLE selected agency from department
// NOTE: in auth0 app_metadata 'department' EQUALS 'agencyId'
    const department = rawAppMetadata.department;

    if (typeof department === 'string' && department !== '*') {
      // single agency ID
      localStorage.setItem('selected_agency', department);
      dispatch(selectAgencyId(department));
    } else {
      // it's "*" or an array — we'll handle that in the UI elsewhere
      console.log('User has multiple or wildcard agencies. Will prompt user to select.');
    }
    // Get token asynchronously
    try {
          const fetchedToken = await getAccessTokenSilently();
          setToken(fetchedToken);
          console.log('🟢 Token fetched and stored');
        } catch (e) {
          console.error('❌ Failed to get access token:', e);
        }
  }
}; 
 setupUser();
}, [isAuthenticated, user, dispatch, getAccessTokenSilently]);


// Watch Redux profile and set app ready ONLY when profile is fully populated
useEffect(() => {
    if (
      reduxProfile.email &&
      reduxProfile.user_metadata &&
      reduxProfile.app_metadata
    ) {
      setIsAppReady(true);
    }
  }, [reduxProfile]);


  useEffect(() => {
  if (!isLoading && !isAuthenticated) {
    console.log('🚪 Detected logout — performing cleanup');

    // 🧹 Clean localStorage
    localStorage.removeItem('selected_agency');
    localStorage.removeItem('profile');

    // Clean up Auth0 SPA SDK leftovers
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && (
      key.startsWith('@@auth0spajs@@') ||
      key.startsWith('com.auth0.auth.')
    )) {
      localStorage.removeItem(key);
    }
  }
    // 🧼 Reset Redux store
    dispatch({ type: 'RESET_PROFILE' });
    dispatch({ type: 'RESET_AGENCY_SELECTION' });
  }
}, [isAuthenticated, isLoading, dispatch]);


 if (error)  return <div>Error: {error.message}</div>; // catch errors first


  if (isLoading) {
    console.log('⏳ Waiting: isLoading or !isAppReady', { isLoading, isAppReady });
    return <LoadingScreen />;
  }
  
  if (!isAuthenticated) {
    console.log('🚫 Not authenticated — returning null');
  return null;
}

if (!isAppReady) {
  console.log('⏳ Waiting: profile not ready (isAppReady = false)');
  return <LoadingScreen />;
}

  return (
    <div className="App">  {/* this is parent component */}
        <Navbar />
        <Main />
        <footer>
          <div>
            The Brass Star Group, LLC: CONFIDENTIAL-COMPANY PROPRIETARY do not
            disclose without written approval.
          </div>
          <div>
            © {year} The Brass Star Group, LLC. All Rights Reserved.
          </div>
        </footer>
      </div>
  );
// }
};

export default App;
